import * as React from 'react';
import { FormGroup, Button, FormControl, ControlLabel, ButtonToolbar, HelpBlock } from 'react-bootstrap';

interface IProps {
    onSave: (firstName: string, lastName: string, email: string, phoneNumber: string) => void
    onCancel: () => void
}

interface IState {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    validation: {
        firstName: boolean,
        lastName: boolean,
        email: boolean,
        phoneNumber: boolean
    },
    dirty: boolean
}

class NewContact extends React.Component<IProps, IState> {
    readonly state: IState = {
        firstName: __ENVIRONMENT__ == 'dev' ? 'Jack' : '',
        lastName: __ENVIRONMENT__ == 'dev' ? 'Beanstalk' : '',
        email: __ENVIRONMENT__ == 'dev' ? 'jb@me.com' : '',
        phoneNumber: __ENVIRONMENT__ == 'dev' ? '2035551212' : '',
        validation: {
            firstName: true,
            lastName: true,
            email: true,
            phoneNumber: true
        },
        dirty: false
    }

    handleFirstNameChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.firstName = e.currentTarget.value != '';

        this.setState({
            firstName: e.currentTarget.value,
            validation
        });
    }

    handleLastNameChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.lastName = e.currentTarget.value != '';

        this.setState({
            lastName: e.currentTarget.value,
            validation
        });
    }

    handleEmailChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.email = e.currentTarget.value != '';

        this.setState({
            email: e.currentTarget.value,
            validation
        });
    }

    handlePhoneNumberChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.phoneNumber = e.currentTarget.value != '';

        this.setState({
            phoneNumber: e.currentTarget.value,
            validation
        });
    }

    handleAddContact = () => {
        let { firstName, lastName, email, phoneNumber } = this.state;

        this.setState({
            validation: {
                firstName: firstName != '',
                lastName: lastName != '',
                email: email != '',
                phoneNumber: phoneNumber != ''
            },
            dirty: true
        }, () => {
            let { firstName, lastName, email, phoneNumber } = this.state;
            let { firstName: vf, lastName: vl, email: ve, phoneNumber: vp } = this.state.validation;
            let isValid = vf && vl && ve && vp;

            if (isValid) {
                this.props.onSave(firstName, lastName, email, phoneNumber);
            }
        });
    }

    render = () => {
        return (
            <div style={{ padding: 15 }}>
                <h1>Add New Contact</h1>

                <FormGroup validationState={!this.state.validation.firstName ? 'error' : null}>
                    <ControlLabel>First Name</ControlLabel>
                    <FormControl
                        value={this.state.firstName}
                        onChange={this.handleFirstNameChange}
                    />

                    {!this.state.validation.firstName && (
                        <HelpBlock>Please specify the first name</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={!this.state.validation.lastName ? 'error' : null}>
                    <ControlLabel>Last Name</ControlLabel>
                    <FormControl
                        value={this.state.lastName}
                        onChange={this.handleLastNameChange}
                    />

                    {!this.state.validation.lastName && (
                        <HelpBlock>Please specify the last name</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={!this.state.validation.email ? 'error' : null}>
                    <ControlLabel>Email</ControlLabel>
                    <FormControl
                        value={this.state.email}
                        onChange={this.handleEmailChange}
                    />

                    {!this.state.validation.email && (
                        <HelpBlock>Please specify the email address</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={!this.state.validation.phoneNumber ? 'error' : null}>
                    <ControlLabel>Phone Number</ControlLabel>
                    <FormControl
                        value={this.state.phoneNumber}
                        onChange={this.handlePhoneNumberChange}
                    />

                    {!this.state.validation.phoneNumber && (
                        <HelpBlock>Please specify the phone number</HelpBlock>
                    )}
                </FormGroup>

                <ButtonToolbar className="pull-right">
                    <Button bsStyle="primary" onClick={this.handleAddContact}>Add Contact</Button>
                    <Button bsStyle="link" onClick={this.props.onCancel}>Cancel</Button>
                </ButtonToolbar>
            </div>
        );
    }
}

export default NewContact;